export function removeTokenScheme(token: string): string {
    const scheme = token?.split(" ")?.[0].toLowerCase();
    if (scheme == "msauth1.0" || scheme == "bearer") {
        return token.split(" ")?.[1];
    }
    
    return token as string;
}
